var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78309 20.9991L21.5323 2.99988",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7491 8.87964C20.8636 9.69316 21.8934 10.6168 22.8229 11.6365C23.098 11.9419 23.2503 12.3384 23.2503 12.7495C23.2503 13.1605 23.098 13.557 22.8229 13.8624C20.257 16.6863 16.0992 19.5682 11.9994 19.4992C10.9829 19.5068 9.97136 19.3591 8.99963 19.0614",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77916 16.2603C2.84594 15.5357 1.97616 14.7328 1.17927 13.8604C0.904163 13.555 0.751923 13.1585 0.751923 12.7475C0.751923 12.3364 0.904163 11.9399 1.17927 11.6345C3.80016 8.75164 7.96899 5.93275 11.9998 5.99975C12.7749 5.99106 13.548 6.07677 14.3021 6.2549",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 8.99963C11.5069 8.9995 11.0192 9.09641 10.5642 9.28481C10.1092 9.47321 9.69575 9.74941 9.34752 10.0976C8.99929 10.4459 8.72308 10.8593 8.53468 11.3143C8.35077 11.7585 8.25405 12.2338 8.24966 12.7143",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 16.4993C12.492 16.4993 12.9797 16.4023 13.4347 16.2138C13.8898 16.0253 14.3032 15.749 14.6514 15.4007C14.9996 15.0524 15.2758 14.6389 15.4642 14.1838C15.6495 13.7362 15.7463 13.2571 15.7493 12.7729",
    stroke: "#71717A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityoff);
export default __webpack_public_path__ + "static/media/visibilityoff.0af124bb422027aab87d13c68c1c250b.svg";
export { ForwardRef as ReactComponent };